import Nps from "./KrNps.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrNps = install(Nps); // 生成带有 install 方法的组件

export default KrNps;
